import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { Country } from "../Country/Country";
/**
 * City class
 */

export class City extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => this.model.id;

    this.getCountryId = () => this.model.countryId;

    this.getCode = () => this.model.code;

    this.getTitle = () => this.model.title;

    this.getRegion = () => this.model.region;

    this.getFullTitle = () => this.model.fullTitle;

    this.isCapital = () => this.model.isCapital;

    this.isRegionalCenter = () => this.model.isRegionalCenter;

    this.getTimeZone = () => this.model.timezone;

    this.getCountry = country => this.getRelation('country', Country, country);
  }

  /**
   * Create city
   *
   * @param {object} object
   *
   * @return {City}
   */
  static create(object) {
    return super.create(object?.result?.model ?? object?.result ?? object);
  }
  /**
   * Create list cities
   *
   * @param {object} objects
   *
   * @return {Array.<City>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map cities
   *
   * @param {Array.<object>} objects
   * @param {function(City): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get city id
   *
   * @return {number}
   */


}